import React, { useMemo, useState } from "react";
import CustomCheckbox from "components/checkbox/custom-checkbox";
import Tag from "components/tag/tag";
import { BsExclamationDiamondFill } from "react-icons/bs";
import _ from "lodash";
import moment from "moment";
import { CoverPlaceholderMilestone } from "constants/images";
import { FiX,FiPlusCircle } from "react-icons/fi";
import toast from "react-hot-toast";

export default function MilestoneList({
  name = "",
  title = "",
  isEdit = false,
  content = [],
  milestones = [],
  onChange,
  onChangeHidePosition,
  milestone_position=[],
  state = {},
  allMilestone={}
}) {
  const [selected, setSelected] = useState(content);
  
    const [hidePosition, setHidePosi] = useState(milestone_position)
    const merged = Object.values(allMilestone).flat();

  const renderStartDate = (data) => {
    const { start_day, start_month, start_year } = data;
    if (start_day && start_month && start_year) {
      return (
        <span>
          {moment(`${start_year} ${start_month} ${start_day}`).format(
            "DD MMM YYYY"
          )}
        </span>
      );
    } else if (start_month && start_year) {
      return (
        <span>
          {moment(start_month).format("MMM")} {start_year}
        </span>
      );
    } else if (start_year) {
      return <span>{start_year}</span>;
    }

    return null;
  };

  const renderEndDate = (data) => {
    const { end_day, end_month, end_year } = data;
    if (end_day && end_month && end_year) {
      return (
        <>
          <span> - </span>
          <span>
            {moment(`${end_year} ${end_month} ${end_day}`).format(
              "DD MMM YYYY"
            )}
          </span>
        </>
      );
    } else if (end_month && end_year) {
      return (
        <>
          <span> - </span>
          <span>
            {moment(end_month).format("MMM")} {end_year}
          </span>
        </>
      );
    } else if (end_year) {
      return (
        <>
          <span> - </span>
          <span>{end_year}</span>
        </>
      );
    }

    return null;
  };

  const onToggleCheckAll = (value) => {
    if (value) {
      if (isEdit) {
        let totalLimit = [...merged, ...milestones];
        // console.log("------------------");
        // console.log(totalLimit);
        // console.log(totalLimit.length);
        if(totalLimit.length > 9 && state?.templateName === "Template Name 5"){
          toast.error("10 Milestone limit reached - deselect one and then try again",{position: 'top-center'});
          return;
        }
        setSelected(milestones);
        onChange(name, milestones);
      } else {
        let totalLimit = [...merged, ...content];
        // console.log("------------------");
        // console.log(totalLimit)
        // console.log(totalLimit.length)
        if(totalLimit.length > 9 && state?.templateName === "Template Name 5"){
          toast.error("10 Milestone limit reached - deselect one and then try again",{position: 'top-center'});
          return;
        }
        setSelected(content);
        onChange(name, content);
      }
    } else {
      setSelected([]);
      onChange(name, []);
    }
  };

  const onCherryPick = (value, record) => {
    let payload = _.clone(selected);
    // console.log(merged.length)
    if(merged.length > 9 && value && state?.templateName === "Template Name 5"){
      toast.error("10 Milestone limit reached - deselect one and then try again",{position: 'top-center'});
      payload.splice(payload.length - 2, 1);
      return;
    }
    let sorted = payload;
    if (value) {
      payload.push(record);
      sorted = _.sortBy(payload, ["id"]);
      setSelected(sorted);
      onChange(name, sorted);
    } else {
      _.remove(payload, function (n) {
        return n?.id === record?.id;
      });
      sorted = _.sortBy(payload, ["id"]);
      setSelected(sorted);
      onChange(name, sorted);
    }
  };

  const global = useMemo(() => {
    let checked = false;
    let size = 0;

    if (isEdit) {
      if (!_.isEmpty(selected)) {
        const filterNonSelected = _.filter(milestones, (e) => {
          let findObject = _.find(selected, ["id", e.id]);
          return _.isEmpty(findObject);
        });

        checked = _.isEmpty(filterNonSelected);
        size = _.size(filterNonSelected);
      }
    } else {
      const filterNonSelected = _.filter(milestones, (e) => {
        if (!_.isEmpty(selected)) {
          let findObject = _.find(selected, ["id", e.id]);
          return _.isEmpty(findObject);
        } else {
          return true;
        }
      });

      checked = _.isEmpty(filterNonSelected);
      size = _.size(filterNonSelected);
    }

    return {
      checked,
      size,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected, content]);

  const showMinus = useMemo(() => {
    let size = _.size(content);
    return !global.checked && global.size > 0 && global.size !== size;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [global, content]);


  const showHideOccupation = (obj) => {
    let hidePos = {
      title: title,
      milestone_id: obj.milestone_id,
      positions: [],
      [obj.milestone_id]:[]
    };
  
  let clonePos = _.cloneDeep(milestone_position || []);

  let found = false;

  clonePos = clonePos.map((item) => {
    if (item.milestone_id === obj.milestone_id) {
      found = true;

      const positions = item[obj.milestone_id] || [];

      if (positions.includes(obj?.position_id)) {
        item[obj.milestone_id] = positions.filter(
          (pos) => pos !== obj?.position_id
        );
      } else {
        item[obj.milestone_id] = [
          ...positions,
          obj?.position_id
        ];
      }
    }

    return item;
  });
  
    // If no matching milestone_id found, add a new entry
    if (!found) {
      hidePos[obj.milestone_id].push(obj?.position_id);
      clonePos.push(hidePos);
    }
    setHidePosi(clonePos)
    onChangeHidePosition(clonePos);
  };
  

  return (
    <section className="w-full">
      {/* header */}
      <div className="w-full flex-group-checkbox py-6 border-y border-resumeBorder">
        <CustomCheckbox
          name={name}
          checked={global.checked}
          showMinus={showMinus}
          onChange={(e) => {
            let value = e.target.checked;
            onToggleCheckAll(value);
          }}
        />
        <h3 className="text-lightBlack text-xl font-semibold">{title}</h3>
      </div>
      {/* start: list */}
      <ul className="w-full pl-0 2sm:pl-8">
        {(milestones || []).map((obj, index) => {
          let findOject = _.find(selected, { id: obj.id });
          let checked = !_.isEmpty(findOject);

          return (
            <li className="w-full flex-group-checkbox py-4" key={index}>
              <CustomCheckbox
                name="all-featured"
                checked={checked}
                onChange={(e) => {
                  let value = e.target.checked;
                  onCherryPick(value, obj);
                }}
              />
              <div className="w-full flex flex-col 2sm:flex-row space-x-3">
                <div className="w-15 h-15 bg-tagBorder rounded-sm relative overflow-hidden">
                  {obj?.isAdultContent && (
                    <div className="absolute matured-content-blured-small">
                      <button className="w-full flex justify-center">
                        <BsExclamationDiamondFill className="text-1xl cursor-pointer" />
                      </button>
                    </div>
                  )}
                  {obj.thumbnail ? (
                    <img
                      alt="milestones"
                      src={obj.thumbnail.url}
                      className="w-full h-full object-contain object-center"
                    />
                  ) :
                    <div className="flex justify-center items-center h-full w-full">
                      <img
                        alt="milestones"
                        src={CoverPlaceholderMilestone}
                        className="w-[50%] object-contain object-center"
                      />
                    </div>
                  }
                </div>
                
                <div style={{ width: "calc(100% - 72px)" }}>
                  <div className="w-full flex flex-row space-x-3 items-center">
                    <p className="text-lightBlack text-sm 2sm:text-xl font-medium">
                      {obj.title}
                    </p>
                    {obj?.categories &&
                        obj?.categories.slice(0, 2).map((c) => { 
                          return <>
                            <Tag>{c.name}</Tag>
                          </>
                        })
                      }  
                    {/* <Tag>{obj.category.name}</Tag> */}
                  </div>
                  <div className="w-full mt-2.4">
                    <p className="text-darkerGray text-sm font-medium leading-6">
                      {renderStartDate(obj)}
                      {renderEndDate(obj)}
                    </p>
                  </div>
                  <div>
                    {
                      <div className="w-full flex flex-wrap gap-1.5">
                          {(obj.positions || []).map((pos,index) => (
                            <div className="relative my-1" key={index}> 
                              <button
                                className={`absolute -right-1 -top-2 text-md font-bold 
                                  ${
                                    hidePosition
                                      .filter(p => p.milestone_id === obj.id)
                                      .some(item =>
                                        item?.[item?.milestone_id]?.includes(pos.position_id)
                                      )
                                      ? "text-[#375ec0]"
                                      : "text-rose-500"
                                  }
                                `}
                                onClick={() => {
                                  showHideOccupation(pos);
                                }}
                              >
                                {
                                  hidePosition
                                    .filter(p => p.milestone_id === obj.id)
                                    .some(item =>
                                      item?.[item?.milestone_id]?.includes(pos.position_id)
                                    )
                                    ? <FiPlusCircle />
                                    : <FiX />
                                }
                              </button>
                              <label
                                key={pos.milestone_id}
                                className="py-2 px-3 rounded-md text-center bg-thBg text-darkerGray text-sm font-medium">
                                {pos.position.name ? pos.position.name : ''}
                              </label>
                            </div>
                          ))}
                      </div>                    
                    }
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
      {/* end list */}
    </section>
  );
}
